class Petitioner {
    id;
    name;
    description;
    highlights;
    photoURL;
    websiteLink;
    createdAt;
    updatedAt;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.highlights = data.highlights;
        this.photoURL = data.photoURL;
        this.websiteLink = data.websiteLink;
        this.createdAt = new Date(data.createdAt);
        this.updatedAt = new Date(data.updatedAt);
    }
}
export default Petitioner;
